import React, { useEffect, useMemo, useState } from 'react';
import { Chart } from 'react-google-charts';
import { fetchCountryData } from '../../api/region';
import { useSelector } from 'react-redux';

// Data for countries with the user count
// export const data = [
//   ['Country', 'User'],
//   ['Germany', 200],
//   ['United States', 300],
//   ['Brazil', 400],
//   ['Canada', 500],
//   ['France', 100],
//   ['India', 129],
//   ['Australia', 250],
//   ['Russia', 350],
//   ['China', 600],
//   ['Japan', 450],
// ];

// Dynamically generate regionsData based on 'data'
// const regionsData = data.slice(1).map((item) => ({
//   name: item[0], // Country name
//   users: item[1], // User count
// }));

const WorldMap = ({ showDetails = true }) => {
  const [data, setData] = useState([['Country', 'User']]);

  const [regionsData, setRegionsData] = useState([]);
  // const { filter } = useSelector((state) => state);
  const filter = useSelector((state) => state.filter);
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, ...rest } = filter;
    return rest;
  }, [JSON.stringify(filter)]);

  const fetchData = async () => {
    try {
      await fetchCountryData(filter, setRegionsData, setData);
    } catch (err) {
      console.error('Error while loading country stats', err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filterWithoutUTM)]);

  return (
    <div className="w-100 text-left mb-4">
      <div className="d-flex justify-content-between gap-4 border rounded-4 p-20">
        <div style={{ width: '100%',}}>
          <Chart
          width="100%"
    height="100%"
            chartEvents={[
              {
                eventName: 'select',
                callback: ({ chartWrapper }) => {
                  const chart = chartWrapper.getChart();
                  const selection = chart.getSelection();
                  if (selection.length === 0) return;
                  const region = data[selection[0].row + 1];
                },
              },
            ]}
            chartType="GeoChart"
            data={data}
            options={{
              displayMode: 'regions',
              resolution: 'countries',
              colorAxis: {
                minValue: 0,
                maxValue: 700,
                colors: ['#dff0ea', '#339AEF'],
              },
              region: 'world',
              chartArea: {
                width: '100%',
                height: '100%',
              },
              legend: {
                position: 'none',
              },
              backgroundColor: 'transparent',
              tooltip: {
                isHtml: true,
                trigger: 'focus',
              },
            }}
          />
        </div>

        {/* Render details only if showDetails is true */}
        {showDetails && (
          <div className="d-flex align-items-center flex-column gap-3 w-100 max-h-500-px">
            {regionsData.map((region, index) => {
              const progressWidth = Math.min((region.users / 700) * 100, 100);
              return (
                <div
                  key={index}
                  className="d-flex align-items-center gap-2 w-100"
                >
                  <div className="w-100 ms-auto">
                    <div className="d-flex justify-content-between align-items-center mb-10">
                      <label className="text-secondary-light font-xs fw-semibold">
                        {region.name}
                      </label>
                      <span className="text-secondary-light font-xs fw-medium line-height-1">
                        {region.users} Users
                      </span>
                    </div>
                    <div
                      className="progress progress-md rounded-pill"
                      role="progressbar"
                      aria-label="User progress"
                      aria-valuenow={progressWidth}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className="progress-bar bg-primary-600 rounded-pill"
                        style={{
                          width: `${progressWidth}%`,
                          transition: 'width 0.5s ease-out',
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default WorldMap;
